'use client';

import { MessageCircle } from 'lucide-react';
import { SITE } from '@/lib/site';

export default function KakaoButton() {
  return (
    <a
      href={SITE.kakao}
      target="_blank"
      rel="noreferrer"
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#FEE500] py-3.5 pl-4 pr-4 font-bold text-[#191919] shadow-[0_10px_30px_-10px_rgba(0,0,0,.35)] transition-all hover:pr-5 sm:bottom-6 sm:right-6"
      aria-label="카카오톡 상담"
    >
      <MessageCircle className="h-5 w-5 fill-[#191919]" />
      <span className="hidden text-sm sm:inline">카톡 상담</span>
    </a>
  );
}
